import { Button } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";
import { useMaybernTableUIContext } from "shared/components/table/maybern/MaybernTableUIContext";

export const DataTableHiddenRows: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const { setFullScreen } = useTableBoxContext();
  const { autoHeightHiddenRowCount } = useMaybernTableUIContext();

  if (autoHeightHiddenRowCount <= 0) {
    return null;
  }

  return (
    <Button
      w="100%"
      h="100%"
      variant="ghost"
      borderRadius="0"
      px="24px"
      py="0"
      minHeight="0"
      color="gray.600"
      justifyContent="flex-start"
      sx={{
        "&&": {
          textStyle: "smallBold",
        },
      }}
      onMouseDownCapture={(e) => {
        e.stopPropagation();
      }}
      onClickCapture={(event) => {
        event.stopPropagation();
        setFullScreen(true);
      }}
    >
      {t("common:table.numRowsHidden", { count: autoHeightHiddenRowCount })}
    </Button>
  );
};
